import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { rem } from '@bonusly/ds-utils';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

export const Checkbox = defineMultiStyleConfig({
	baseStyle: {
		control: {
			borderRadius: rem(6),
			borderWidth: '1px',
			borderColor: 'border.default',
			bgColor: 'bg.surface',
			position: 'relative',
			w: 5,
			h: 5,
			_hover: {
				borderColor: 'border.strong',
			},
			_checked: {
				bgColor: 'primary.bg',
				borderColor: 'primary.bg',
				color: 'white',
				_hover: {
					bgColor: 'primary.bgHover',
					borderColor: 'primary.bgHover',
				},
				_disabled: {
					bgColor: 'bg.disabled',
					borderColor: 'border.soft',
					color: 'text.disabled',
				},
			},
			// Mirrors `_checked` — without this, the "select all" header checkbox's
			// partial-selection state falls through to Chakra's base theme, which
			// paints it with the default `colorScheme` (blue) instead of the app's
			// primary color.
			_indeterminate: {
				bgColor: 'primary.bg',
				borderColor: 'primary.bg',
				color: 'white',
				_hover: {
					bgColor: 'primary.bgHover',
					borderColor: 'primary.bgHover',
				},
			},
			_disabled: {
				bgColor: 'bg.disabled',
				borderColor: 'border.soft',
			},
		},
	},
	sizes: {
		sm: {
			control: {
				borderRadius: rem(5),
				top: rem(1.5),
				w: 4,
				h: 4,
			},
		},
	},
	variants: {
		circle: {
			control: {
				borderRadius: 'full',
			},
		},
	},
});
